var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.stars),function(star,index){return _c('i',{key:index,class:`fa ${star} ${_vm.size}`})}),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[(_vm.displayRatingValue)?_c('span',[_vm._v(_vm._s(`(${_vm.value}/5)`))]):_vm._e(),_c('span',[_vm._v("x"+_vm._s(_vm.nbClientsVoted))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }